/** Named opacity values. Can be used in `opacity` or `rgba()` for example. */
export var opacity = {
    /** 0.5 */
    subdued: 0.5,
    /** 0.34 */
    subtle: 0.34,
    /** 0.9 */
    tint: 0.9
};
//# sourceMappingURL=opacity.js.map